import {
    TOOL_REGISTRATION_CONTEXT,
    TOOL_REGISTRATION_STEPS
} from "@omni/services/tracking/trackers/tools/registration/config";
import * as ToolsStepTracker from "@omni/services/tracking/trackers/tools/toolStep.tracker";
import { createUserId } from "@omni/services/tracking/trackers/utils";
import { StepVariables } from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

export const trackStart = () => {
    ToolsStepTracker.track(
        TOOL_REGISTRATION_STEPS.start,
        TOOL_REGISTRATION_CONTEXT
    );
};

export const trackSubmit = (registrationResult: any) => {
    if (!registrationResult) return;

    const customerId = createUserId(registrationResult.email);
    const step: StepVariables = {
        ...TOOL_REGISTRATION_STEPS.submit,
        result: {
            customerid: customerId,
            newsletteroptin: registrationResult.newsLetterSubscribed
        }
    };

    ToolsStepTracker.trackSubmit(step, TOOL_REGISTRATION_CONTEXT);
};
